module.exports = __webpack_public_path__ + "static/media/67.49f01bc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/67.jpg
// module id = 627
// module chunks = 0